import React, { useState, useEffect, useCallback } from "react";
import API from "../services/api";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "../styles/allHistory.css";

export default function AllHistory() {

    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [searchType, setSearchType] = useState("name");
    const [searchVal, setSearchVal] = useState("");


    const today = new Date().toISOString().split("T")[0];


    const [selectedDate, setSelectedDate] = useState(today);
    const [filterType, setFilterType] = useState("today");


    // Initial state: Default "date" select rahega


    // const [filterType, setFilterType] = useState("month"); // month / today

    const [dateType, setDateType] = useState("date"); // UI

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1); // 🔥 goes to previous page
    };

    // 🔥 FETCH DATA
    const fetchData = useCallback(async () => {
        try {
            const res = await API.get(
                `/billing/advanced-history?page=${page}&search=${searchVal}&type=${searchType}&date=${selectedDate}&filter=${filterType}`
            );

            if (res.data.success) {
                setData(res.data.data);
                setTotalPages(res.data.totalPages);
            }
        } catch (err) {
            console.error(err);
        }
    }, [page, searchVal, searchType, selectedDate, filterType]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDateTypeChange = (type) => {
        setDateType(type);

        if (type === "date") {
            // set today date
            const today = new Date().toISOString().split("T")[0];
            setSelectedDate(today);
            setFilterType("today");
        } else {
            // set current month
            const today = new Date();
            const month = today.toISOString().slice(0, 7); // YYYY-MM
            setSelectedDate(month);
            setFilterType("month");
        }

        setPage(1);
    };




    const handlePDFType = async (type, mobile = "", customDate = selectedDate) => {
        try {
            const res = await API.get(
                `/billing/advanced-history?page=1&limit=1000&search=${mobile}&type=mobile&date=${customDate}&filter=${type}`
            );

            if (!res.data.success || res.data.data.length === 0) {
                return Swal.fire("No Data", "Koi data nahi mila", "info");
            }

            generatePDF(res.data.data, type.toUpperCase());

        } catch (err) {
            console.error(err);
            Swal.fire("Error", "PDF generate nahi hua", "error");
        }
    };




    // 🔥 APPLY FILTER
    const applyFilter = () => {
        setPage(1);

        if (!selectedDate) {
            Swal.fire("Select Date", "Please select date or month", "warning");
            return;
        }

        if (dateType === "date") {
            setFilterType("today");
        } else {
            setFilterType("month");
        }
    };

    // 🔥 PDF GENERATOR
    // 🔥 PDF GENERATOR WITH ITEMS
    const generatePDF = (records, title = "Report") => {
        if (!records || records.length === 0) {
            return Swal.fire("No Data", "PDF ke liye data nahi hai", "info");
        }

        const doc = new jsPDF("p", "mm", "a4");

        const money = (amount) => `Rs. ${Number(amount || 0).toFixed(2)}`;

        const formatDate = (date) => {
            return new Date(date).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
        };

        const formatMonth = (date) => {
            return new Date(date).toLocaleDateString("en-IN", {
                month: "long",
                year: "numeric",
            });
        };

        // Header
        doc.setFillColor(15, 23, 42);
        doc.rect(0, 0, 210, 30, "F");

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(18);
        doc.text("Bhopal Seat Cover", 14, 13);

        doc.setFontSize(11);
        doc.text(title, 14, 22);

        doc.setTextColor(0, 0, 0);

        let y = 38;

        // ✅ GROUP BY SAME CUSTOMER + MOBILE
        const groupedCustomers = records.reduce((acc, r) => {
            const key = `${r.customerName || "Unknown"}_${r.customerMobile || "N/A"}`;

            if (!acc[key]) {
                acc[key] = {
                    customerName: r.customerName || "-",
                    customerMobile: r.customerMobile || "N/A",
                    bills: [],
                };
            }

            acc[key].bills.push(r);
            return acc;
        }, {});

        Object.values(groupedCustomers).forEach((customer, customerIndex) => {
            if (y > 240) {
                doc.addPage();
                y = 20;
            }

            const totalAmount = customer.bills.reduce((sum, b) => sum + Number(b.totalAmount || 0), 0);
            const totalPaid = customer.bills.reduce((sum, b) => sum + Number(b.paidAmount || 0), 0);
            const totalDue = customer.bills.reduce((sum, b) => sum + Number(b.dueAmount || 0), 0);

            // ✅ CUSTOMER DETAILS ONLY ONCE
            autoTable(doc, {
                startY: y,
                theme: "grid",
                head: [[`Customer ${customerIndex + 1}`, "Details"]],
                body: [
                    ["Name", customer.customerName],
                    ["Mobile", customer.customerMobile],
                    ["Total Bills", customer.bills.length],
                    ["Total Amount", money(totalAmount)],
                    ["Total Paid", money(totalPaid)],
                    ["Total Due", money(totalDue)],
                ],
                headStyles: {
                    fillColor: [15, 23, 42],
                    textColor: 255,
                },
                styles: {
                    fontSize: 9,
                    cellPadding: 2,
                },
                columnStyles: {
                    0: { fontStyle: "bold", cellWidth: 45 },
                    1: { cellWidth: 135 },
                },
            });

            y = doc.lastAutoTable.finalY + 6;

            // ✅ MONTH WISE GROUP
            const monthGroups = customer.bills.reduce((acc, bill) => {
                const monthKey = formatMonth(bill.date);

                if (!acc[monthKey]) {
                    acc[monthKey] = [];
                }

                acc[monthKey].push(bill);
                return acc;
            }, {});

            Object.entries(monthGroups).forEach(([monthName, bills]) => {
                if (y > 250) {
                    doc.addPage();
                    y = 20;
                }

                doc.setFillColor(37, 99, 235);
                doc.rect(14, y, 182, 8, "F");

                doc.setTextColor(255, 255, 255);
                doc.setFontSize(11);
                doc.text(monthName, 16, y + 5.5);

                doc.setTextColor(0, 0, 0);
                y += 12;

                bills.forEach((bill, billIndex) => {
                    if (y > 235) {
                        doc.addPage();
                        y = 20;
                    }

                    const status = Number(bill.dueAmount || 0) === 0 ? "PAID" : "UNPAID";

                    // ✅ BILL SUMMARY
                    autoTable(doc, {
                        startY: y,
                        theme: "grid",
                        head: [[`Bill ${billIndex + 1}`, "Amount"]],
                        body: [
                            ["Date", formatDate(bill.date)],
                            ["Sub Total", money(bill.subTotal)],
                            ["Discount", money(bill.discount)],
                            ["Total", money(bill.totalAmount)],
                            ["Paid", money(bill.paidAmount)],
                            ["Due", money(bill.dueAmount)],
                            ["Status", status],
                        ],
                        headStyles: {
                            fillColor: [30, 41, 59],
                            textColor: 255,
                        },
                        styles: {
                            fontSize: 8.5,
                            cellPadding: 2,
                        },
                        columnStyles: {
                            0: { fontStyle: "bold", cellWidth: 45 },
                            1: { cellWidth: 135 },
                        },
                    });

                    y = doc.lastAutoTable.finalY + 3;

                    // ✅ ITEMS
                    const itemRows = (bill.items || []).map((item, i) => {
                        const qty = Number(item.qty || 0);
                        const price = Number(item.price || 0);

                        return [
                            i + 1,
                            item.name || "-",
                            `${qty} ${item.unit || ""}`,
                            money(price),
                            money(qty * price),
                        ];
                    });

                    autoTable(doc, {
                        startY: y,
                        theme: "striped",
                        head: [["#", "Item", "Qty / Unit", "Price", "Amount"]],
                        body: itemRows.length
                            ? itemRows
                            : [["-", "No items found", "-", "-", "-"]],
                        headStyles: {
                            fillColor: [59, 130, 246],
                            textColor: 255,
                        },
                        styles: {
                            fontSize: 8,
                            cellPadding: 2,
                        },
                        columnStyles: {
                            0: { cellWidth: 12, halign: "center" },
                            1: { cellWidth: 78 },
                            2: { cellWidth: 28, halign: "center" },
                            3: { cellWidth: 28, halign: "right" },
                            4: { cellWidth: 32, halign: "right" },
                        },
                    });

                    y = doc.lastAutoTable.finalY + 7;
                });
            });

            y += 5;
        });

        // Footer
        const pageCount = doc.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(120);
            doc.text(`Page ${i} of ${pageCount}`, 180, 290);
            doc.text("Generated by Bhopal Seat Cover", 14, 290);
        }

        doc.save(`Report_${title.replaceAll(" ", "_")}.pdf`);
    };

    // 🔥 PDF OPTIONS
    const handlePDFOptions = async () => {

        const result = await Swal.fire({
            title: "Select Report Type",
            html: `
        <div class="pdf-options">
            <button id="dateBtn">Selected Date</button>
            <button id="monthBtn">Selected Month</button>
            <button id="todayBtn">Today</button>
            <button id="thisMonthBtn">This Month</button>
            <button id="yearBtn">This Year</button>
            <button id="allBtn">All Time</button>
        </div>
        `,
            showCancelButton: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {

                document.getElementById("dateBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("today");
                };

                document.getElementById("monthBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("month");
                };

                document.getElementById("todayBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("today");
                };

                document.getElementById("thisMonthBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("month");
                };

                document.getElementById("yearBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("year");
                };

                document.getElementById("allBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("all");
                };
            }
        });

    };

    // 🔥 TODAY BUTTON
    const handleTodayFilter = () => {
        const today = new Date().toISOString().split("T")[0];

        setSelectedDate(today);
        setFilterType("today");
        setPage(1);
    };

    const handleThisMonth = () => {
        const today = new Date();
        const currentMonth = today.toISOString().slice(0, 7); // YYYY-MM

        setDateType("month");
        setSelectedDate(currentMonth);
        setFilterType("month");
        setPage(1);
    };




    const handlePDFClick = async (item) => {

        await Swal.fire({
            title: "Customer Report",
            html: `
        <div class="pdf-options">
            <button id="todayBtn">Today</button>
            <button id="monthBtn">This Month</button>
            <button id="yearBtn">This Year</button>
            <button id="allBtn">All Time</button>
        </div>
        `,
            showCancelButton: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {

                document.getElementById("todayBtn").onclick = () => {
                    Swal.close();

                    const purchaseDate = new Date(item.date).toISOString().split("T")[0];

                    handlePDFType("today", item.customerMobile, purchaseDate);
                };

                document.getElementById("monthBtn").onclick = () => {
                    Swal.close();

                    const purchaseMonth = new Date(item.date).toISOString().slice(0, 7);

                    handlePDFType("month", item.customerMobile, purchaseMonth);
                };

                document.getElementById("yearBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("year", item.customerMobile);
                };

                document.getElementById("allBtn").onclick = () => {
                    Swal.close();
                    handlePDFType("all", item.customerMobile);
                };
            }
        });

    };





    // useEffect(() => {
    //     fetchData();
    // }, [selectedDate, filterType]);

    // const downloadPDF = (data, title = "Report") => {
    //     const doc = new jsPDF();

    //     doc.setFontSize(18);
    //     doc.text("Bhopal Seat Cover", 14, 15);

    //     doc.setFontSize(12);
    //     doc.text(title, 14, 25);

    //     const tableColumn = [
    //         "Date",
    //         "Customer",
    //         "Total",
    //         "Paid",
    //         "Due",
    //         "Status"
    //     ];

    //     const tableRows = data.map((item) => [
    //         new Date(item.date).toLocaleDateString(),
    //         item.customerName,
    //         `₹${item.totalAmount}`,
    //         `₹${item.paidAmount}`,
    //         `₹${item.dueAmount}`,
    //         item.dueAmount === 0 ? "PAID" : "UNPAID"
    //     ]);

    //     autoTable(doc, {
    //         head: [tableColumn],
    //         body: tableRows,
    //         startY: 30,
    //     });

    //     doc.save(`${title}.pdf`);
    // };

    return (


        <div className="layout">
            <Sidebar />

            <div className="main-content">

                <div className="history-container">


                    <div className="top-bar">
                        <div className="left-controls">

                            {/* Search Type */}
                            <select
                                value={searchType}
                                onChange={(e) => {
                                    setSearchType(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <option value="name">Name</option>
                                <option value="mobile">Mobile</option>
                            </select>

                            {/* Search Input */}
                            <input
                                type="text"
                                placeholder={searchType === "name" ? "Search by name..." : "Search by mobile..."}
                                value={searchVal}
                                onChange={(e) => {
                                    setSearchVal(e.target.value);
                                    setPage(1);
                                }}
                            />

                            {/* Date Type */}
                            <select
                                value={dateType}
                                onChange={(e) => handleDateTypeChange(e.target.value)}
                            >
                                <option value="date">Date</option>
                                <option value="month">Month</option>
                            </select>

                            {/* Date / Month Input */}
                            <input
                                type={dateType === "month" ? "month" : "date"}
                                value={selectedDate}
                                onChange={(e) => {
                                    setSelectedDate(e.target.value);
                                    setFilterType(dateType === "date" ? "today" : "month");
                                    setPage(1);
                                }}
                            />

                            <button onClick={applyFilter}>Apply</button>

                            <div className="filter-buttons">
                                <button onClick={handleTodayFilter}>Today</button>
                                <button onClick={handleThisMonth}>This Month</button>
                            </div>

                            <button onClick={handlePDFOptions}>Download PDF</button>
                        </div>

                        <div className="right-controls">
                            <button onClick={handleBack} className="back-btn">← Back</button>
                        </div>
                    </div>

                    {/* 📊 TABLE */}
                    <table className="history-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Total</th>
                                <th>Paid</th>
                                <th>Due</th>
                                <th>Status</th>
                                <th>Paid Date</th>
                                <th>PDF</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                                        No Data Found
                                    </td>
                                </tr>
                            ) : (
                                data.map((item) => (
                                    <tr key={item._id}>
                                        <td>{new Date(item.date).toLocaleDateString()}</td>
                                        <td>{item.customerName}</td>
                                        <td>{item.customerMobile}</td>
                                        <td>₹{item.totalAmount}</td>
                                        <td>₹{item.paidAmount}</td>

                                        <td style={{ color: item.dueAmount > 0 ? "red" : "green" }}>
                                            ₹{item.dueAmount}
                                        </td>

                                        <td className={item.dueAmount === 0 ? "paid" : "due"}>
                                            {item.dueAmount === 0 ? "PAID" : "UNPAID"}
                                        </td>

                                        <td>
                                            {item.dueAmount === 0
                                                ? new Date(item.date).toLocaleDateString()
                                                : "-"}
                                        </td>

                                        <td>
                                            <button
                                                className="pdf-btn"
                                                onClick={() => handlePDFClick(item)}
                                            >
                                                📄 PDF
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {/* 🔄 PAGINATION */}
                    <div className="pagination">
                        <button
                            disabled={page === 1 || totalPages === 0}
                            onClick={() => setPage(page - 1)}
                        >
                            Prev
                        </button>

                        <span>
                            Page {totalPages === 0 ? 0 : page} / {totalPages}
                        </span>

                        <button
                            disabled={page >= totalPages || totalPages === 0}
                            onClick={() => setPage(page + 1)}
                        >
                            Next
                        </button>
                    </div>

                </div>

            </div>
        </div>


    );
}